import React, { useState } from 'react'

import {
  Typography,
  Button
} from '@telavita-core/react-design-kit'

import { RequestTokenModal } from 'components'
import TimerContainer from '../../containers/TimerContainer'

import { useScheduleToken } from 'hooks/useScheduleToken'

import * as S from './styles'

interface NotificationInlineProps {
  initialTime: number
  virtualRoomHash: string
  isTimeUp: boolean
  tokenHasBeenFilled: boolean | null
  planGroupCode: string
  startDate: string
  endDate: string
  scheduleId: number
  planGroupName: string
}

const NotificationInline = ({ 
  initialTime, 
  virtualRoomHash, 
  isTimeUp,
  tokenHasBeenFilled,
  planGroupCode,
  startDate,
  endDate,
  scheduleId,
  planGroupName,
}: NotificationInlineProps): JSX.Element => {
  const [timeUp, setTimeUp] = useState(isTimeUp)

  const { onJoinVirtualRoom, openTokenModal, onCloseModal, onClickJoinVirtualRoom } = useScheduleToken({
    schedule: {
      endDate,
      startDate,
      tokenHasBeenFilled,
      virtualRoomHash,
      planGroupCode,
    }
  })

  return (
    <S.Container>
      {timeUp ? (
        <Typography variant='content3'>Já começou!</Typography>
      ) : (
        <>
          <Typography variant='content3'>Começa em</Typography>

          <TimerContainer
            initialTime={initialTime}
            onTimerStop={() => setTimeUp(true)}
          />
        </>
      )}
      <Button
        onClick={() => onJoinVirtualRoom()}
        variant='contained'
        customClassName='JoinVirtualRoomButton'
      >
        Entrar
      </Button>
      {openTokenModal && (
        <RequestTokenModal
          planGroupName={planGroupName}
          planGroupCode={planGroupCode}
          onClose={onCloseModal}
          scheduleId={scheduleId}
          onClickJoinVirtualRoom={onClickJoinVirtualRoom}
        />
      )}
    </S.Container>
  )
}

export default NotificationInline
